import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { specials } from "@/mocks/specials";

const SOCIALS = [
  { icon: "ri-weibo-line", label: "微博", href: "https://weibo.com" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩", href: "https://www.bilibili.com" },
  { icon: "ri-book-2-line", label: "小红书", href: "https://www.xiaohongshu.com" },
  { icon: "ri-youtube-line", label: "YouTube", href: "https://www.youtube.com" },
  { icon: "ri-tiktok-line", label: "抖音", href: "https://www.douyin.com" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-primary-50/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-heart-3-fill" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                糖心Vlog
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              糖心Vlog 是一个专注真实生活记录与精彩视频分享的个人视频博客。我们相信平凡的日子也值得被认真记录，
              用镜头收藏日常、旅行与思考的每一个瞬间。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-lg text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-950">
              <a href="/#latest" className="hover:text-primary-600">
                视频分类
              </a>
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-600">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="transition-colors hover:text-primary-600">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-950">
              <a href="/#specials" className="hover:text-primary-600">
                精选专题
              </a>
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-600">
              {specials.map((s) => (
                <li key={s.id}>
                  <Link to={`/special/${s.id}`} className="transition-colors hover:text-primary-600">
                    {s.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-600">
                  关于与联系
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 糖心Vlog · 记录真实生活与精彩视频分享</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/about" className="whitespace-nowrap transition-colors hover:text-primary-600">
              使用须知
            </Link>
            <span className="whitespace-nowrap">本站内容为真实生活记录与演示数据</span>
          </p>
        </div>
      </div>
    </footer>
  );
}